import Icon from '@ant-design/icons';

const EstimateIconSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.09578 3.14258C8.31038 3.14258 8.50765 3.26041 8.60939 3.44935L12.9027 11.4227C13.0001 11.6035 12.9952 11.8221 12.8899 11.9984C12.7846 12.1746 12.5944 12.2826 12.3891 12.2826H3.80245C3.59713 12.2826 3.40693 12.1746 3.30165 11.9984C3.19636 11.8221 3.1915 11.6035 3.28884 11.4227L7.58218 3.44935C7.68392 3.26041 7.88119 3.14258 8.09578 3.14258ZM4.77908 11.1159H11.4125L8.09578 4.95631L4.77908 11.1159Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EstimateIcon = (props: any) => <Icon component={EstimateIconSvg} {...props} />;
